export default __webpack_public_path__ + "static/media/AES_D.a82307aa.svg";